export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0016s_0000_Black-&-White-46.c8ec1e06.png";